import { maskWithLast4Digits } from 'helpers/fieldFormatters'
import { ReactElement } from 'react'
import i18n from 'lang/i18n'
import { HiddenLabelText } from './subcomponents'

export interface MaskNumberProps {
  /** value to be used for masking */
  lastFourDigits: string
  /** char to be used as masking character */
  maskChar?: string
  /** number of masked characters */
  charCount: number
}

/**
 * This component will mask the account number and routing number. It will return the masked number
 * wrapped inside the span tag and masked character as aria-hidden=true to avoid the
 * accessibility issues.
 */
const MaskNumber = ({
  lastFourDigits: value,
  maskChar = '•',
  charCount = 1
}: MaskNumberProps): ReactElement => {
  // Generate the masked value
  const maskedValue = maskWithLast4Digits(value, maskChar, charCount)
  const maskedString = maskedValue.slice(0, charCount)
  const unmaskedString = maskedValue.slice(charCount)

  return (
    <span>
      <span aria-hidden="true">{maskedString}</span>
      <HiddenLabelText>{i18n({ label: 'ending in' })}</HiddenLabelText>
      {unmaskedString}
    </span>
  )
}

export default MaskNumber
